module.exports = __webpack_public_path__ + "static/media/ErrorImage.42d3e1b1.png";